module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/hero_mob-d06e0ac1d9de1913c5f8b3991cc884cb.jpg";